import { gql } from '@apollo/client/core'
import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'

import { HOLE_FRAGMENT } from '@base/api/fragments/hole'

export const GET_HOLES_FOR_COURSE_QUERY = gql`
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}
  ${SERVER_ERROR}
  ${HOLE_FRAGMENT}

  query getHolesForCourse($slug: String, $offset: Int, $limit: Int) {
    listHoles(
      filter: { courseSlug: $slug }
      sort: [{ sortField: POSITION, sortOrder: ASC }]
      offset: $offset
      limit: $limit
    ) {
      ... on ListHolesOutput {
        holes {
          ...Hole
        }
        count
      }
      ... on ListHolesErrorOutput {
        errors {
          courseId
          courseSlug
          filter
          sort
          limit
          offset
        }
      }
      ...ServerError
      ...UnauthorizedError
      ...UnauthenticatedError
    }
  }
`
